import { ErrorBoundary, useContext } from 'solid-js';
import { styled } from 'solid-styled-components';
import { AppContext } from '../app-context-provider/app-context-provider';
import { logErrorToServer } from './log-error-to-server';

type ErrorCatcherProps = {
    componentName: string;
    children: any;
    logErrorToServer?: boolean;
}

const StyledErrorCatcher = styled.div`
    z-index: 100;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    background-color: lightcoral;
    color: white;
    padding: 1rem;
`;

export const ErrorCatcher = (props: ErrorCatcherProps) => {
    const { siteInfo, viewport } = useContext(AppContext);

    const logError = (error: Error) => {
        logErrorToServer({
            message: error.message,
            url: window.location.href,
            componentName: props.componentName,
            error,
            viewport,
        });
    };
    
    return (
        <ErrorBoundary fallback={(err: Error) => {
            const message = `Error caught in ${props.componentName} on ${siteInfo.name} - ${siteInfo.url}: `;
            console.error(message, err);

            if (props.logErrorToServer) {
                logError(err);
            }
            
            return (
                <StyledErrorCatcher>
                    {message}: {err?.toString()}
                </StyledErrorCatcher>
            );
        }}>
            {props.children}
        </ErrorBoundary>
    );
};